import { ArithmeticSequenceWidgetConfig } from '../arithmetic-sequence.model';
import { ARITHMETIC_EXPLORATION_PRESET } from './exploration.preset';

export interface ArithmeticPreset {
  id: string;
  title: string;
  description: string;
  config: ArithmeticSequenceWidgetConfig;
}

export const ARITHMETIC_PRESETS = {
  exploration: ARITHMETIC_EXPLORATION_PRESET,
} as const;

export type ArithmeticPresetId = keyof typeof ARITHMETIC_PRESETS;
